module.exports = __webpack_public_path__ + "img/001-account.cfd83bf3.svg";